import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from '@/modern/components/Link'
import { cleanText } from '../../utils/utils'
import { config } from 'config/config.js'
import { fetchAdvertiserAreaDetail } from '@/ducks/advertiserArea'
import { DAY_OF_WEEK, VEHICLE_TYPE } from '@/utils/constants'
import { sendDispatchEvent, onClientSide } from '@/utils/utils'

import Button from '../Button'
import InformationStatusStore from './InformationStatusStore'
import * as S from './style'
import AboutSeller from '@/modern/components/SellerArea/AboutSeller'
import SellerAchievements from '@/modern/components/SellerArea/SellerAchievements'
class CardDealership extends Component {
  constructor(props) {
    super(props)

    this.state = {
      storeClosed: false,
      adArearesult: {},
      hasScheduleHours: false,
    }

    this.getOperatingHours = this.getOperatingHours.bind(this)
    this.getValuesOperatingHours = this.getValuesOperatingHours.bind(this)
    this.getValueOperatingHoursWeek = this.getValueOperatingHoursWeek.bind(this)
    this.handleClickStore = this.handleClickStore.bind(this)
  }

  componentDidUpdate(prevProps) {
    const isOnClientSide = onClientSide()
    if (isOnClientSide) {
      const phoneNumbers = document.querySelectorAll(
        '.CardSeller__phone__number'
      )

      const { showButtonPhone, loading } = this.props

      if (!showButtonPhone && phoneNumbers.length) {
        phoneNumbers.forEach(item =>
          item.classList.add('CardSeller__phone__number--active')
        )
      }

      const phoneViews = document.querySelectorAll('.CardSeller__phone__view')

      if (loading && phoneViews.length) {
        phoneViews.forEach(item => {
          item.classList.add('CardSeller__phone__view--loading')
        })
      }
      if (this.props.dealerSchedule !== prevProps.dealerSchedule) {
        if(this.props.dealerSchedule && this.props.dealerSchedule.business_hours){
          const schedule = this.props.dealerSchedule.business_hours;
          const hasSundaySchedule = this.isDealerOpenToday(schedule)
          this.setState({ hasScheduleHours: hasSundaySchedule })
        }
      }
    }
  }

  componentDidMount() {
    if (!onClientSide()) return;
    this.getAdvertiserAreaData()
  }

  handleDataAdArea(ad) {
    if (!ad || !ad.Specification) return;

    const { Specification, UniqueId, Type } = ad;
    const parsedBrand = cleanText(Specification.Make.Value);
    const parsedModel = cleanText(Specification.Model.Value);
    const parsedYear = parseInt(Specification.YearFabrication, 10);

    const commonData = {
      type: Type,
      brand: parsedBrand,
      model: parsedModel,
      year: parsedYear,
      idAnuncio: UniqueId,
    };

    if (Type === 'car') {
      const parsedVersion = cleanText(Specification.Version.Value);
      return { ...commonData, version: parsedVersion };
    } else if (Type === 'bike') {
      return { ...commonData, version: Specification.CubicCentimeter };
    }
    return null;
  }

  getAdvertiserAreaData() {
    const { ad } = this.props;
    if (!ad || !ad.Seller || ad.Seller.SellerType === 'PF' || ad.Type === 'bike') return;

    const data = this.handleDataAdArea(ad)

    if (this.props.advertiserArea && !this.props.advertiserArea.fetched) {
      this.props.dispatch(fetchAdvertiserAreaDetail(data)).then(() => {
       this.setState({ adArearesult: this.props.advertiserArea.result })
      })
    }
  }

  transformToHour(timestamp) {
    if (!timestamp || typeof timestamp !== 'string') return '';

    const timeParts = timestamp.split(':');

    if (timeParts.length < 2) return '';

    const [hour, minute] = timeParts;

    if (isNaN(hour) || isNaN(minute)) return '';

    return `${parseInt(hour)}h${String(minute).padStart(2, '0')}`;
  }

  getNextDayOfWeek() {
    const today = new Date();
    const currentDayOfWeek = today.getDay();
    const currentTime = `${String(today.getHours()).padStart(2, '0')}:${String(today.getMinutes()).padStart(2, '0')}:${String(today.getSeconds()).padStart(2, '0')}`;
    const weekDays = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
    const schedule = this.props.dealerSchedule ? this.props.dealerSchedule.business_hours : [];

    if (!Array.isArray(schedule) || schedule.length === 0) return null;

    for (let i = 0; i < 7; i++) {
      const nextDayOfWeek = (currentDayOfWeek + i) % 7;
      const daySchedule = schedule.find(d => parseInt(d.day_of_week) === nextDayOfWeek);

      if (daySchedule) {
        if (i === 0) {
          if (currentTime >= daySchedule.opening && currentTime <= daySchedule.closing) {
            return {
              nextOpenDay: weekDays[currentDayOfWeek],
              nextOpeningTime: daySchedule.opening,
              closingHour: daySchedule.closing
            }
          } else if (currentTime < daySchedule.opening) {
            return {
              nextOpenDay: weekDays[currentDayOfWeek],
              nextOpeningTime: daySchedule.opening,
              closingHour: daySchedule.closing
            }
          }
        } else if (daySchedule.opening !== '00:00:00' && daySchedule.closing !== '00:00:00') {
          return {
            nextOpenDay: weekDays[nextDayOfWeek],
            nextOpeningTime: daySchedule.opening,
            closingHour: daySchedule.closing
          };
        }
      }
    }
    return {
      nextOpenDay: "",
      nextOpeningTime: "",
      closingHour: ""
    };
  }

  renderClosedMessage() {
    const nextDayOfWeekInfo = this.getNextDayOfWeek();
    if (!nextDayOfWeekInfo) return;

    const { nextOpenDay, nextOpeningTime } = nextDayOfWeekInfo;
    const startTime = this.transformToHour(nextOpeningTime);

    return `Loja fechada ${startTime && startTime !== '00:00:00' ? '- Abre ' + nextOpenDay + ' às ' + startTime : ''}`;
  }

  getOperatingHours() {
    const _arrayTitle = []
    const _arrayHours = []
    const weekShedule = []

    const { dealerSchedule } = this.props

    if (dealerSchedule && dealerSchedule.business_hours) {
      let _monday = 'Fechado'
      let _tuesday = 'Fechado'
      let _wednesday = 'Fechado'
      let _thursday = 'Fechado'
      let _friday = 'Fechado'
      let _saturday = 'Fechado'
      let _sunday = 'Fechado'
      let _holiday = 'Fechado'

      const _newTimeSpan = '00:00:00.0000000'
      const _dateNowTime = new Date()

      this.props.dealerSchedule.business_hours.map((value, key) => {
        switch (value.day_of_week) {
          case '0':
            if (
              !(value.opening == _newTimeSpan && value.closing == _newTimeSpan)
            ) {
              _sunday = `${value.opening.substring(
                0,
                5
              )} - ${value.closing.substring(0, 5)}`

              const [beginHour, beginMinute] = value.opening
                .substring(0, 5)
                .split(':')
              const [endHour, endMinute] = value.closing
                .substring(0, 5)
                .split(':')

              const dateBegin = new Date()
              const dateEnd = new Date()

              dateBegin.setHours(Number(beginHour), Number(beginMinute), 0, 0)
              dateEnd.setHours(Number(endHour), Number(endMinute), 0, 0)

              weekShedule[0] = { start: dateBegin, end: dateEnd }

              const isToday = _dateNowTime.getDay() == '0'
              const title = this.getValuesOperatingHours(
                _dateNowTime,
                _sunday,
                isToday,
                key
              )
              const hour = this.getValueOperatingHoursWeek(
                _sunday,
                DAY_OF_WEEK.SUNDAY.DESCRIPTION,
                key
              )
              _arrayTitle.push(title)
              _arrayHours.push(hour)

              break
            } else {
              const hour = this.getValueOperatingHoursWeek(
                'Fechado',
                DAY_OF_WEEK.SUNDAY.DESCRIPTION,
                key
              )
              _arrayHours.push(hour)
            }
            break
          case '1':
            if (
              !(value.opening == _newTimeSpan && value.closing == _newTimeSpan)
            ) {
              _monday = `${value.opening.substring(
                0,
                5
              )} - ${value.closing.substring(0, 5)}`

              const [beginHour, beginMinute] = value.opening
                .substring(0, 5)
                .split(':')
              const [endHour, endMinute] = value.closing
                .substring(0, 5)
                .split(':')

              const dateBegin = new Date()
              const dateEnd = new Date()

              dateBegin.setHours(Number(beginHour), Number(beginMinute), 0, 0)
              dateEnd.setHours(Number(endHour), Number(endMinute), 0, 0)

              weekShedule[1] = { start: dateBegin, end: dateEnd }

              const isToday = _dateNowTime.getDay() == '1'
              const title = this.getValuesOperatingHours(
                _dateNowTime,
                _monday,
                isToday,
                key
              )
              const hour = this.getValueOperatingHoursWeek(
                _monday,
                DAY_OF_WEEK.MONDAY.DESCRIPTION,
                key
              )
              _arrayTitle.push(title)
              _arrayHours.push(hour)
            } else {
              const hour = this.getValueOperatingHoursWeek(
                'Fechado',
                DAY_OF_WEEK.MONDAY.DESCRIPTION,
                key
              )
              _arrayHours.push(hour)
            }
            break
          case '2':
            if (
              !(value.opening == _newTimeSpan && value.closing == _newTimeSpan)
            ) {
              _tuesday = `${value.opening.substring(
                0,
                5
              )} - ${value.closing.substring(0, 5)}`

              const [beginHour, beginMinute] = value.opening
                .substring(0, 5)
                .split(':')
              const [endHour, endMinute] = value.closing
                .substring(0, 5)
                .split(':')

              const dateBegin = new Date()
              const dateEnd = new Date()

              dateBegin.setHours(Number(beginHour), Number(beginMinute), 0, 0)
              dateEnd.setHours(Number(endHour), Number(endMinute), 0, 0)

              weekShedule[2] = { start: dateBegin, end: dateEnd }

              const isToday = _dateNowTime.getDay() == '2'
              const title = this.getValuesOperatingHours(
                _dateNowTime,
                _tuesday,
                isToday,
                key
              )
              const hour = this.getValueOperatingHoursWeek(
                _tuesday,
                DAY_OF_WEEK.TUESDAY.DESCRIPTION,
                key
              )
              _arrayTitle.push(title)
              _arrayHours.push(hour)
            } else {
              const hour = this.getValueOperatingHoursWeek(
                'Fechado',
                DAY_OF_WEEK.TUESDAY.DESCRIPTION,
                key
              )
              _arrayHours.push(hour)
            }
            break
          case '3':
            if (
              !(value.opening == _newTimeSpan && value.closing == _newTimeSpan)
            ) {
              _wednesday = `${value.opening.substring(
                0,
                5
              )} - ${value.closing.substring(0, 5)}`

              const [beginHour, beginMinute] = value.opening
                .substring(0, 5)
                .split(':')
              const [endHour, endMinute] = value.closing
                .substring(0, 5)
                .split(':')

              const dateBegin = new Date()
              const dateEnd = new Date()

              dateBegin.setHours(Number(beginHour), Number(beginMinute), 0, 0)
              dateEnd.setHours(Number(endHour), Number(endMinute), 0, 0)

              weekShedule[3] = { start: dateBegin, end: dateEnd }

              const isToday = _dateNowTime.getDay() == '3'
              const title = this.getValuesOperatingHours(
                _dateNowTime,
                _wednesday,
                isToday,
                key
              )
              const hour = this.getValueOperatingHoursWeek(
                _wednesday,
                DAY_OF_WEEK.WEDNESDAY.DESCRIPTION,
                key
              )
              _arrayTitle.push(title)
              _arrayHours.push(hour)
            } else {
              const hour = this.getValueOperatingHoursWeek(
                'Fechado',
                DAY_OF_WEEK.WEDNESDAY.DESCRIPTION,
                key
              )
              _arrayHours.push(hour)
            }
            break
          case '4':
            if (
              !(value.opening == _newTimeSpan && value.closing == _newTimeSpan)
            ) {
              _thursday = `${value.opening.substring(
                0,
                5
              )} - ${value.closing.substring(0, 5)}`

              const [beginHour, beginMinute] = value.opening
                .substring(0, 5)
                .split(':')
              const [endHour, endMinute] = value.closing
                .substring(0, 5)
                .split(':')

              const dateBegin = new Date()
              const dateEnd = new Date()

              dateBegin.setHours(Number(beginHour), Number(beginMinute), 0, 0)
              dateEnd.setHours(Number(endHour), Number(endMinute), 0, 0)

              weekShedule[4] = { start: dateBegin, end: dateEnd }

              const isToday = _dateNowTime.getDay() == '4'
              const title = this.getValuesOperatingHours(
                _dateNowTime,
                _thursday,
                isToday,
                key
              )
              const hour = this.getValueOperatingHoursWeek(
                _thursday,
                DAY_OF_WEEK.THURSDAY.DESCRIPTION,
                key
              )
              _arrayTitle.push(title)
              _arrayHours.push(hour)
            } else {
              const hour = this.getValueOperatingHoursWeek(
                'Fechado',
                DAY_OF_WEEK.THURSDAY.DESCRIPTION,
                key
              )
              _arrayHours.push(hour)
            }
            break
          case '5':
            if (
              !(value.opening == _newTimeSpan && value.closing == _newTimeSpan)
            ) {
              _friday = `${value.opening.substring(
                0,
                5
              )} - ${value.closing.substring(0, 5)}`

              const [beginHour, beginMinute] = value.opening
                .substring(0, 5)
                .split(':')
              const [endHour, endMinute] = value.closing
                .substring(0, 5)
                .split(':')

              const dateBegin = new Date()
              const dateEnd = new Date()

              dateBegin.setHours(Number(beginHour), Number(beginMinute), 0, 0)
              dateEnd.setHours(Number(endHour), Number(endMinute), 0, 0)

              weekShedule[5] = { start: dateBegin, end: dateEnd }

              const isToday = _dateNowTime.getDay() == '5'
              const title = this.getValuesOperatingHours(
                _dateNowTime,
                _friday,
                isToday,
                key
              )
              const hour = this.getValueOperatingHoursWeek(
                _friday,
                DAY_OF_WEEK.FRIDAY.DESCRIPTION,
                key
              )
              _arrayTitle.push(title)
              _arrayHours.push(hour)
            } else {
              const hour = this.getValueOperatingHoursWeek(
                'Fechado',
                DAY_OF_WEEK.FRIDAY.DESCRIPTION
              )
              _arrayHours.push(hour)
            }
            break
          case '6':
            if (
              !(value.opening == _newTimeSpan && value.closing == _newTimeSpan)
            ) {
              _saturday = `${value.opening.substring(
                0,
                5
              )} - ${value.closing.substring(0, 5)}`

              const [beginHour, beginMinute] = value.opening
                .substring(0, 5)
                .split(':')
              const [endHour, endMinute] = value.closing
                .substring(0, 5)
                .split(':')

              const dateBegin = new Date()
              const dateEnd = new Date()

              dateBegin.setHours(Number(beginHour), Number(beginMinute), 0, 0)
              dateEnd.setHours(Number(endHour), Number(endMinute), 0, 0)

              weekShedule[6] = { start: dateBegin, end: dateEnd }

              const isToday = _dateNowTime.getDay() == '6'
              const title = this.getValuesOperatingHours(
                _dateNowTime,
                _saturday,
                isToday,
                key
              )
              const hour = this.getValueOperatingHoursWeek(
                _saturday,
                DAY_OF_WEEK.SATURDAY.DESCRIPTION,
                key
              )
              _arrayTitle.push(title)
              _arrayHours.push(hour)
            } else {
              const hour = this.getValueOperatingHoursWeek(
                'Fechado',
                DAY_OF_WEEK.SATURDAY.DESCRIPTION,
                key
              )
              _arrayHours.push(hour)
            }
            break
          case '7':
            if (
              !(value.opening == _newTimeSpan && value.closing == _newTimeSpan)
            ) {
              _holiday = `${value.opening.substring(
                0,
                5
              )} - ${value.closing.substring(0, 5)}`

              const [beginHour, beginMinute] = value.opening
                .substring(0, 5)
                .split(':')
              const [endHour, endMinute] = value.closing
                .substring(0, 5)
                .split(':')

              const dateBegin = new Date()
              const dateEnd = new Date()

              dateBegin.setHours(Number(beginHour), Number(beginMinute), 0, 0)
              dateEnd.setHours(Number(endHour), Number(endMinute), 0, 0)

              weekShedule[7] = { start: dateBegin, end: dateEnd }

              const isToday = false
              const title = this.getValuesOperatingHours(
                _dateNowTime,
                _holiday,
                isToday,
                key
              )
              const hour = this.getValueOperatingHoursWeek(
                _holiday,
                DAY_OF_WEEK.HOLIDAYS.DESCRIPTION,
                key
              )
              _arrayTitle.push(title)
              _arrayHours.push(hour)
            } else {
              const hour = this.getValueOperatingHoursWeek(
                'Fechado',
                DAY_OF_WEEK.HOLIDAYS.DESCRIPTION,
                key
              )
              _arrayHours.push(hour)
            }
            break

          default:
            break
        }
      })
    }
    const { data, dispatch } = this.props
    const { Photo } = data

    dispatch({
      type: '@newSellerInfo/SET',
      key: 'weekSchedule',
      value: weekShedule,
    })
    dispatch({
      type: '@newSellerInfo/SET',
      key: 'badge',
      value: !!Photo && `${Photo}?s=fill&w=128&h=40&q=70&t=true`,
    })
    return { _arrayTitle, _arrayHours }
  }

  isDealerOpenToday(dealerSchedule) {
    const currentDayOfWeek = new Date().getDay();
    if (!dealerSchedule || !Array.isArray(dealerSchedule)) {
      return false;
    }
    return !(currentDayOfWeek === 0 && !dealerSchedule.some(d => parseInt(d.day_of_week) === 0));
  }

  getValuesOperatingHours(dateNowTime, hours, isToday, key) {
    const { storeClosed } = this.state

    const defaultPropsInformationStatusComponent = {
      key,
      onClick: this.handleClickStore,
    }

    const itsClosed = hours.includes('Fechado')

    if (!itsClosed) {
      const _startDateHour = new Date()
      const _endDateHour = new Date(_startDateHour)
      _startDateHour.setHours(
        hours.substring(0, 2),
        hours.substring(3, 5),
        '00'
      )
      _endDateHour.setHours(
        hours.substring(8, 10),
        hours.substring(11, 13),
        '00'
      )

      const classNameIcon = `arrow ${storeClosed ? 'arrow--up' : ''}`

      if (
        dateNowTime >= _startDateHour &&
        dateNowTime <= _endDateHour &&
        isToday
      ) {
        const closeAt = `${hours.substring(8, 10)}h${hours.substring(11, 13)}`
        const message = `Loja aberta agora - Fecha às ${closeAt}`
        return (
          <InformationStatusStore {...defaultPropsInformationStatusComponent}>
            <span className='open'>{message}</span>
            <i className={classNameIcon} />
          </InformationStatusStore>
        )
      }

      if (
        (dateNowTime < _startDateHour || dateNowTime > _endDateHour) &&
        isToday
      ) {
        return (
          <InformationStatusStore {...defaultPropsInformationStatusComponent}>
            <span className='closed'>{this.renderClosedMessage()}</span>
            <i className={classNameIcon} />
          </InformationStatusStore>
        )
      }
    } else {
      return (
        <InformationStatusStore {...defaultPropsInformationStatusComponent}>
          {hours} agora
        </InformationStatusStore>
      )
    }
  }

  getValueOperatingHoursWeek(hours, dayofWeek, key) {
    let _hours

    _hours = (
      <tr key={key} className="CardSeller__store__schedule__tr">
        <td className="CardSeller__store__schedule__tr__td CardSeller__store__schedule__tr__td--weekday">
          {dayofWeek}:
        </td>
        <td className="CardSeller__store__schedule__tr__td CardSeller__store__schedule__tr__td--hours">
          {hours}
        </td>
      </tr>
    )

    return _hours
  }

  handleClickStore() {
    this.setState({ storeClosed: !this.state.storeClosed }, () => {
      if (this.state.storeClosed) sendDispatchEvent('horario-funcionamento', '')
    })
  }

  isUnavailable() {
    const { ad } = this.props
    return ad && ad.Seller.ExceededPlan
  }

  render() {
    const result = this.getOperatingHours()
    const {
      ad,
      data,
      vehicleType,
      showButtonPhone,
      phonesDetail,
      seePhone,
      loading,
    } = this.props
    const {
      Photo,
      UniqueId,
      searchVehiclesSeller,
      TypeCar,
      Phone,
    } = data

    const scheduleHoursArray = result &&
      Array.isArray(result._arrayHours)
    ? result._arrayHours : [];

    return (
      <S.Container>
        <div
          className={`CardSeller CardSeller--dealership${
            Photo ? ' CardSeller--dealership-photo' : ''
          }`}
        >
          <AboutSeller data={this.props.data} />

          <div className="CardSeller__container">
            <div className="CardSeller__container__left">
              <div>

                  {scheduleHoursArray.length && this.state.hasScheduleHours ?
                  <div
                  id="VehicleSellerInformationStore"
                  className="CardSeller__store"
                  >
                    {result._arrayTitle}
                    {this.state.storeClosed ? (
                      <table className="CardSeller__store__schedule">
                        <tbody>{result._arrayHours}</tbody>
                      </table>
                    ) : undefined}
                  </div> : null}
              </div>
            </div>
            {VEHICLE_TYPE.car == vehicleType ? (
              <div className="CardSeller__container__right">
                {Phone && Phone.length > 0 ? (
                  <div
                    id="VehicleSellerInformationBoxPhone"
                    className="CardSeller__phone"
                  >
                    <div className="CardSeller__box__phone">
                      {showButtonPhone ? (
                        <strong
                          id="VehicleSellerInformationPhone_"
                          className="CardSeller__phone__number"
                        >
                          <small className="CardSeller__phone__number__ddd">
                            {Phone[0].ddd}
                          </small>
                          {Phone[0].number}
                        </strong>
                      ) : phonesDetail ? (
                        phonesDetail.map((element, key) => {
                          return (
                            <strong
                              key={key}
                              id={`VehicleSellerInformationPhone_${key}`}
                              className="CardSeller__phone__number"
                            >
                              <small className="CardSeller__phone__number__ddd">
                                {element.ddd}
                              </small>
                              {element.number}
                            </strong>
                          )
                        })
                      ) : undefined}
                    </div>
                    {showButtonPhone ? (
                      <Button
                        className=" CardSeller__phone__view"
                        name="CardSeller__phone__view"
                        id="CardSellerPhoneViewPrivate"
                        type="submit"
                        onClick={seePhone}
                      >
                        {loading ? 'carregando...' : 'Ver telefone'}
                      </Button>
                    ) : undefined}
                  </div>
                ) : undefined}
                {!this.isUnavailable() && (
                  <div
                    id="VehicleSellerInformationBoxCode"
                    className="CardSeller__code"
                  >
                    <p
                      id="VehicleSellerInformationCode"
                      className="CardSeller__code__connection"
                    >
                      Na ligação informe o código:{' '}
                      <strong className="CardSeller__code__connection__number">
                        {UniqueId.toString().substring(
                          UniqueId.toString().length - 4
                        )}
                      </strong>
                    </p>
                  </div>
                )}
              </div>
            ) : Phone && Phone.length > 0 ? (
              <div className="CardSeller__container__right">
                <div
                  id="VehicleSellerInformationBoxPhone"
                  className="CardSeller__phone"
                >
                  <div className="CardSeller__box__phone">
                    {Phone.map((element, key) => {
                      return (
                        <strong
                          key={key}
                          id={`VehicleSellerInformationPhone_${key}`}
                          className="CardSeller__phone__number CardSeller__phone__number--active"
                        >
                          <small className="CardSeller__phone__number__ddd">
                            {element.ddd}
                          </small>
                          {element.number}
                        </strong>
                      )
                    })}
                  </div>
                </div>
              </div>
            ) : undefined}
          </div>
          <div className="CardSeller__stock">
            <Link
              data-qa="see_all_seller_stock"
              to={searchVehiclesSeller()}
              id="VehicleSellerInformationStock"
              className="CardSeller__stock__seller"
            >
              {`Ver todos ${TypeCar ? 'os carros' : 'as motos'} deste vendedor`}
              <i className="CardSeller__stock__seller__arrow CardSeller__stock__seller__arrow--right" />
            </Link>
          </div>
        </div>
      {this.state.adArearesult && (
        <Fragment>
          <S.Border />
          <SellerAchievements
            ad={this.props.ad}
            adArea={this.state.adArearesult}
          />
        </Fragment>
      )}
    </S.Container>

    )
  }
}

export default connect(store => {
  return {
    newSellerInfo: store.newSellerInfo,
    advertiserArea: store.advertiserAreaState,
  }
})(CardDealership)
